import { RootState } from "../store/community-finder-redux-store";

export const selectIsQmiFinder = (state: RootState) => state?.appStatus?.isQmiFinder;
